var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddOrg = function SvgAddOrg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.412 21.564"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".add-org_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-org_svg__f76c7bd2-7ba4-4c80-a5d6-86cc1e8543e8",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-org_svg__be557b76-3647-4b5d-8719-a6dc2ff05367",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.954 4.136v11.818",
    className: "add-org_svg__st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.636,
    height: 3.636,
    x: 4.136,
    y: 0.5,
    className: "add-org_svg__st0",
    rx: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.545,
    height: 4.545,
    x: 8.682,
    y: 15.954,
    className: "add-org_svg__st0",
    rx: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.545,
    height: 4.545,
    x: 0.5,
    y: 15.954,
    className: "add-org_svg__st0",
    rx: 0.909
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.545 10.5H4.135a.91.91 0 0 0-.909.91v4.546",
    className: "add-org_svg__st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add-org_svg__beb23c06-ac02-4262-8f76-9b3e8d31f877",
    className: "add-org_svg__st0",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add-org_svg__bef30d3e-35aa-4c26-b7e6-6e837162a1b3",
    d: "M19.662 21.064a4.25 4.25 0 1 0-4.25-4.25 4.25 4.25 0 0 0 4.25 4.25",
    className: "add-org_svg__st0",
    "data-name": "Oval 119"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add-org_svg__fd96bf87-5d64-4bca-8f78-417b6864828e",
    d: "M19.662 14.689v4.25",
    className: "add-org_svg__st0",
    "data-name": "Shape 417"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add-org_svg__bb042232-fc88-42cf-8215-d7e7b40807a9",
    d: "M21.787 16.814h-4.25",
    className: "add-org_svg__st0",
    "data-name": "Shape 418"
  })))));
};
export { SvgAddOrg as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC40MTE3IDIxLjU2MzgiPgogIDx0aXRsZT5hZGQtb3JnPC90aXRsZT4KICA8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30KPC9zdHlsZT4KICA8ZyBpZD0iZjc2YzdiZDItN2JhNC00YzgwLWE1ZDYtODZjYzFlODU0M2U4IiBkYXRhLW5hbWU9IkxheWVyIDIiPgogICAgPGcgaWQ9ImJlNTU3Yjc2LTM2NDctNGI1ZC04NzE5LWE2ZGMyZmYwNTM2NyIgZGF0YS1uYW1lPSJMYXllciAxIj4KICAgICAgPGc+CiAgICAgICAgPGxpbmUgY2xhc3M9InN0MCIgeDE9IjEwLjk1NDUiIHkxPSI0LjEzNjQiIHgyPSIxMC45NTQ1IiB5Mj0iMTUuOTU0NSIgLz4KICAgICAgICA8cmVjdCBjbGFzcz0ic3QwIiB4PSI0LjEzNjQiIHk9IjAuNSIgd2lkdGg9IjEzLjYzNjQiIGhlaWdodD0iMy42MzY0IiByeD0iMC45MDkxIiAvPgogICAgICAgIDxyZWN0IGNsYXNzPSJzdDAiIHg9IjguNjgxOCIgeT0iMTUuOTU0NSIgd2lkdGg9IjQuNTQ1NSIgaGVpZ2h0PSI0LjU0NTUiIHJ4PSIwLjkwOTEiIC8+CiAgICAgICAgPHJlY3QgY2xhc3M9InN0MCIgeD0iMC41IiB5PSIxNS45NTQ1IiB3aWR0aD0iNC41NDU1IiBoZWlnaHQ9IjQuNTQ1NSIgcng9IjAuOTA5MSIgLz4KICAgICAgICA8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTkuNTQ0NSwxMC41MDA5SDQuMTM2NGEuOTA5MS45MDkxLDAsMCwwLS45MDkxLjkwOTF2NC41NDU1IiAvPgogICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZyBjbGFzcz0ic3QwIiBpZD0iYmViMjNjMDYtYWMwMi00MjYyLThmNzYtOWIzZThkMzFmODc3IiBkYXRhLW5hbWU9Iklzb2xhdGlvbiBNb2RlIj4KICAgICAgPHBhdGggY2xhc3M9InN0MCIgaWQ9ImJlZjMwZDNlLTM1YWEtNGMyNi1iN2U2LTZlODM3MTYyYTFiMyIgZGF0YS1uYW1lPSJPdmFsIDExOSIgZD0iTTE5LjY2MTcsMjEuMDYzOGE0LjI1LDQuMjUsMCwxLDAtNC4yNS00LjI1QTQuMjUsNC4yNSwwLDAsMCwxOS42NjE3LDIxLjA2MzhaIiAvPgogICAgICA8cGF0aCBjbGFzcz0ic3QwIiBpZD0iZmQ5NmJmODctNWQ2NC00YmNhLThmNzgtNDE3YjY4NjQ4MjhlIiBkYXRhLW5hbWU9IlNoYXBlIDQxNyIgZD0iTTE5LjY2MTcsMTQuNjg4OHY0LjI1IiAvPgogICAgICA8cGF0aCBjbGFzcz0ic3QwIiBpZD0iYmIwNDIyMzItZmM4OC00MmNmLTgyMTUtZDdlN2I0MDgwN2E5IiBkYXRhLW5hbWU9IlNoYXBlIDQxOCIgZD0iTTIxLjc4NjcsMTYuODEzOGgtNC4yNSIgLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";